import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaUserResolver_GetOwnedBuckets = UsersTableDefinitionZod.shape.ownedBuckets;

export type SchemaUserResolver_GetOwnedBuckets = z.infer<typeof schemaUserResolver_GetOwnedBuckets>;

export type UserResolver_GetOwnedBuckets = Resolver<Arguments, SchemaUserResolver_GetOwnedBuckets>;
